<script setup>
import { computed } from 'vue'
import { getI18n } from '@/plugins/i18n'

import { DxTextBox } from 'devextreme-vue/text-box'

import { useRegistryStore } from '@/stores/registry.store'
import { useWebSiteStore } from '@/stores/web-site.store'

const i18n = getI18n()

const props = defineProps({
  data: {
    type: Object,
    default: null,
  },
  selectedBrandId: {
    type: Number,
    default: null,
  },
  selectedQuantity: {
    type: Number,
    default: null,
  },
  selectedUomId: {
    type: Number,
    default: null,
  },
})

const registryStore = useRegistryStore()
const webSiteStore = useWebSiteStore()

const selectedUOM = computed(() => {
  if (!props.selectedUomId) return null

  return webSiteStore.unitsOfMeasure.find(u => u.id === props.selectedUomId) || null
})

const selectedBrand = computed(() => {
  if (!props.selectedBrandId) return null

  return registryStore.supplierBrands.find(b => b.id === props.selectedBrandId) || null
})

const timeEquivalent = computed(() => {
  if (!selectedBrand.value || !props.selectedQuantity || !selectedUOM.value) return null

  if (!selectedUOM.value) return null

  const qty = props.selectedQuantity
  const minPerUl = selectedBrand.value.min_per_ul

  const locale = i18n.global?.locale

  const nf = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })

  let minutes
  switch (selectedUOM.value.code) {
    case webSiteStore.unitOfMeasureOfTimeEnum.UL: minutes = qty * minPerUl; break
    case webSiteStore.unitOfMeasureOfTimeEnum.HR: minutes = qty * 60; break
    case webSiteStore.unitOfMeasureOfTimeEnum.MN: minutes = qty; break
    default: return null
  }

  const hours = nf.format(minutes / 60)
  const ul = nf.format(minutes / minPerUl)

  return `${minutes} ${i18n.t('common.minuteAlt')} - ${hours} ${hours === '1' ? i18n.t('common.hour') : i18n.t('common.hour', 2)} - ${ul} ${i18n.t('common.laborUnitAlt')}`
})

</script>
<template>
  <dx-text-box
    class="time-equivalent-textbox"
    :value="timeEquivalent"
    :disabled="true"
  />
</template>

<style scoped lang="scss">
.time-equivalent-textbox {
  min-height: 2rem;
  :deep(.dx-texteditor-container .dx-texteditor-input-container .dx-texteditor-input) {
    font-size: 0.625rem !important;
  }
}

</style>
